import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, AlertCircle } from "lucide-react";

const ADMIN_PASSWORD = "0507";

export function PasswordDialog({ open, onClose, onSuccess, title = "Autenticação Necessária", description = "Digite a senha de administrador para continuar" }) {
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);

  // Limpar ao abrir/fechar
  useEffect(() => {
    if (open) {
      setPassword("");
      setError(false);
    }
  }, [open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (password === ADMIN_PASSWORD) {
      setError(false);
      setPassword("");
      onSuccess();
      onClose();
    } else {
      setError(true);
      setPassword("");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" aria-describedby="password-dialog-description">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Lock className="w-5 h-5 text-amber-600" />
            {title}
          </DialogTitle>
          <DialogDescription id="password-dialog-description">
            {description}
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="admin-password">Senha de Administrador</Label>
            <Input
              id="admin-password"
              type="password"
              placeholder="Digite a senha"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError(false);
              }}
              autoFocus
              className={error ? "border-red-500 focus:border-red-500" : ""}
            />
            {error && (
              <div className="flex items-center gap-2 text-sm text-red-600">
                <AlertCircle className="w-4 h-4" />
                <span>Senha incorreta. Tente novamente.</span>
              </div>
            )}
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose}>
              Cancelar
            </Button>
            <Button type="submit" className="bg-teal-700 hover:bg-teal-800">
              Confirmar
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default PasswordDialog;
